'use client';

import { Button, type ButtonProps, cn, Div, Span } from '@scatterlab/zeta-core';
import { memo, ReactNode } from 'react';

export type ToggleProps = ButtonProps & {
  label?: ReactNode;
  value: boolean;
};

const Toggle = ({ label, value, className, ...props }: ToggleProps) => (
  <Button
    type="button"
    className={cn('flex cursor-pointer flex-row items-center gap-2', className)}
    {...props}
  >
    <Div
      className={cn(
        'flex h-[18px] w-8 flex-row items-center rounded-full bg-gray-800 px-0.5 transition-colors',
        {
          'bg-primary-400 pl-4': value,
          'bg-gray-700': props.disabled,
          'bg-primary-500': value && props.disabled,
        },
      )}
    >
      <Div
        className={cn(
          'size-[14px] rounded-full bg-white shadow-300',
          props.disabled && 'bg-white/50',
        )}
      />
    </Div>
    {typeof label === 'string' ? (
      <Span className="button14 select-none text-white">{label}</Span>
    ) : (
      label
    )}
  </Button>
);

export default memo(Toggle);
